//@ts-ignore
import React from 'react'; // TODO: fix types
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './components/app';
import { SocketWrapper } from './components/socket';

const container = document?.getElementById('root');
const initialData = (window as any).__INITIAL_DATA__ || {};

hydrateRoot(container,
  <BrowserRouter basename={'/api/ssr'}>
      <App initialData={initialData} />
  </BrowserRouter>,
);

n